function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveOnlyfans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-7ac81ee0-8a3b-4c4b-8a95-a275c3f8932d",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.27 41.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-fe886abf-cb81-4586-9f60-fa072bce8bca",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.64,0h0C9.24,0,0,9.24,0,20.64h0c0,11.4,9.24,20.64,20.64,20.64h0c11.4,0,20.64-9.24,20.64-20.64h0C41.27,9.24,32.03,0,20.64,0ZM28.52,18.67c2.59.75,5.65,0,5.65,0-.89,3.87-3.7,6.3-7.75,6.6-.6,1.38-1.49,2.6-2.6,3.58,0,0,0,0-.01.01-.18.16-.36.31-.55.45,0,0,0,0-.01.01-.19.15-.38.28-.58.42,0,0-.01,0-.02.01-.2.13-.4.25-.6.37,0,0-.01,0-.02,0-.21.12-.43.23-.65.33,0,0,0,0,0,0-.21.1-.43.19-.65.28-.01,0-.02,0-.03.01-.22.09-.45.16-.68.23,0,0,0,0-.01,0-.21.06-.43.12-.65.17-.03,0-.07.02-.1.02-.22.05-.45.09-.68.13-.02,0-.04,0-.06,0-.2.03-.4.05-.61.07-.06,0-.12,0-.18.01-.22.01-.45.02-.67.02-5.63,0-10.2-4.57-10.2-10.2s4.56-10.2,10.2-10.2c2.55,0,4.88.94,6.66,2.48,1.85-2.24,4.21-2.48,8.61-2.48h5.12c-.86,3.77-3.81,6.66-8.93,7.65Z",
    style: {
      fill: "#ff9be7",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.07,24.28h0c-1.69,0-3.06-1.37-3.06-3.06s1.37-3.06,3.06-3.06,3.06,1.37,3.06,3.06c0,1.69-1.36,3.06-3.05,3.06",
    style: {
      fill: "#ff9be7",
      strokeWidth: 0
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveOnlyfans);
export default __webpack_public_path__ + "static/media/activeOnlyfans.326e84f424d2a3dea6b9b42999ef10e0.svg";
export { ForwardRef as ReactComponent };